/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IMonitorVideoStreamsModalScope extends ng.IScope {
        monitorVideoStreams: Models.MonitorVideoStream[];
        modalClose: () => void;
        selectVideoStream: (selectedMonitorVideoStream: Models.MonitorVideoStream) => void;
        newVideoStream: () => void;
        getValidMonitorVideoStreams: () => Models.MonitorVideoStream[];
    }

    export class MonitorVideoStreamsModalController {
        public static templateURL: string = "decorators/modals/monitor-video-streams-modal.html";
        public static ID: string = "#id-monitor-video-streams-modal";
        public static $name: string = "monitorVideoStreamsModalController";
        public static $inject: string[] = ['$scope', 'close', 'monitorVideoStreams'];

        private $scope: IMonitorVideoStreamsModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IMonitorVideoStreamsModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    monitorVideoStreams: Models.MonitorVideoStream[]) {
            this.$scope = $scope;
            this.close = close;
            this.$scope.monitorVideoStreams = this.filterVideoStreams(monitorVideoStreams);
            
            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };
            
            this.$scope.selectVideoStream = (monitorVideoStream: Models.MonitorVideoStream): void => {
                this.close(monitorVideoStream);
            };
            
            this.$scope.newVideoStream = (): void => {
                this.close(Models.MonitorVideoStream.Empty());
            };
        }

        private filterVideoStreams(monitorVideoStreams: Models.MonitorVideoStream[]): Models.MonitorVideoStream[] {
            let validMonitors: Models.MonitorVideoStream[] = [];

            for (let monitor of monitorVideoStreams) {
                if (monitor.href !== monitor.sourceName) {
                    validMonitors.push(monitor);
                }
            }

            return validMonitors;
        }
    }
}
